<script lang="ts" setup>
import { useAdmissionReleaseInfo } from '@sancare/typescript-commons/src/composables/useAdmissionReleaseInfo'
import dayjs from '@sancare/typescript-commons/src/misc/dayjs'
import { computed } from 'vue'
import { useI18n } from 'vue-i18n'

import { Rhs, SmrStay } from '@/store/modules/stay/smr/types'

const { t } = useI18n()
const props = defineProps<{
  stay: SmrStay
  displayedRhs?: Rhs | null
  rhsIndex?: number
}>()

const firstRhs = computed(() => props.stay.rhsList.length > 0 ? props.stay.rhsList[0] : null)
const lastRhs = computed(() => props.stay.rhsList.length > 0 ? props.stay.rhsList[props.stay.rhsList.length - 1] : null)
const formattedSurgeryDate = computed(
  () => props.stay.surgeryDate ? dayjs(props.stay.surgeryDate).format('DD MMM YYYY') : '-'
)

const {
  admissionMode,
  releaseMode,
  origin,
  destination,
  admissionTooltip,
  releaseTooltip,
} = useAdmissionReleaseInfo(() => ({
  admissionMode: firstRhs.value?.admissionMode ?? null,
  releaseMode: lastRhs.value?.releaseMode ?? null,
  origin: firstRhs.value?.origin ?? null,
  destination: lastRhs.value?.destination ?? null,
}), undefined, t)
</script>

<template>
  <div class="d-flex flex-column gap-2">
    <span class="ms-0 text-muted small">
      {{ t('stayDisplayer.stay') }}
    </span>
    <span class="ms-0 fw-bold text-nowrap">
      {{ dayjs(props.stay.stayStart).format('DD MMM YYYY') }} - {{ dayjs(props.stay.stayEnd).format('DD MMM YYYY') }}
    </span>
    <span class="ms-0">
      {{ props.stay.stayDuration }} {{ t('stayDisplayer.day', props.stay.stayDuration) }}<span v-if="props.stay.presenceDayCount">
        ({{ props.stay.presenceDayCount }}&nbsp;{{ t('stayDisplayer.generalStayData.presenceDay', props.stay.presenceDayCount) }})
      </span>
    </span>
    <span class="ms-0">
      <span
        v-tooltip="{
          content: admissionTooltip,
          placement: 'top',
          html: true
        }"
        class="cursor-pointer"
      >
        {{ t('stayDisplayer.generalStayData.entryDate') }}:
        {{ admissionMode }}/{{ origin }}
      </span>
      —
      <span
        v-tooltip="{
          content: releaseTooltip,
          placement: 'top',
          html: true
        }"
        class="cursor-pointer"
      >
        {{ t('stayDisplayer.generalStayData.exitDate') }}:
        {{ releaseMode }}/{{ destination }}
      </span>
    </span>
    <span class="ms-0">
      {{ t('stayDisplayer.generalStayData.surgeryDateShort') }}: {{ formattedSurgeryDate }}
    </span>
  </div>
</template>
